import api from '../../api/index'
import * as types from '../../types/index'

export default {
  actions: {
    [types.UPDATE_PASSWORD] ({dispatch, commit, getters}, params) {
      return api.updatePassword({
        token: getters[types.GET_USER].token,
        oldPwd: params.oldPwd,
        newPwd: params.newPwd
      }).then((res) => {
        const resData = res.data

        if (Number(resData.code) === 0) {
          dispatch(types.SET_SUCCESS_MESSAGE, {
            show: true,
            content: resData.result
          })
        } else if (Number(resData.code) === 999) {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
          commit(types.SET_USER, {})
          params.router.push('/login')
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: resData.result
          })
        }
        return res
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/personalCenter/updatePassword.js